import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";

import { Button } from "@/components/common/Button";
import { Field } from "@/components/application-form/Field";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/services/api";

export default function AdminLoginPage() {
  const { adminLogin } = useAuth();
  const navigate = useNavigate();

  const [busy, setBusy] = useState(false);

  const [admin, setAdmin] = useState({
    email: "",
    password: "",
  });

  const onAdmin = (name, value) => {
    setAdmin((state) => ({
      ...state,
      [name]: value,
    }));
  };

  async function submit(e) {
    e.preventDefault();

    setBusy(true);

    try {
      await adminLogin(admin);

      toast.success("Admin login successful");

      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div data-testid="admin-login-page">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-slate-900">
          <ShieldCheck className="h-5 w-5 text-white" />
        </div>

        <div>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">
            Admin Login
          </h1>

          <p className="mt-1 text-sm text-slate-500">
            Sign in to the CET examination administration panel.
          </p>
        </div>
      </div>

      <form onSubmit={submit} className="mt-6 space-y-5">
        <Field
          label="Admin Email"
          name="email"
          type="email"
          value={admin.email}
          onChange={onAdmin}
          placeholder="admin@example.com"
          required
          testId="admin-login-email"
          autoComplete="username"
        />

        <Field
          label="Password"
          name="password"
          type="password"
          value={admin.password}
          onChange={onAdmin}
          placeholder="Your password"
          required
          testId="admin-login-password"
          autoComplete="current-password"
        />

        <Button
          as="button"
          type="submit"
          className="w-full"
          disabled={busy}
          data-testid="admin-login-submit-btn"
        >
          {busy ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <>
              <ShieldCheck className="h-4 w-4" />
              Admin Sign In
            </>
          )}
        </Button>
      </form>
    </div>
  );
}